import { useEffect } from 'react';

/**
 * Hook to update the document title
 */
export function useDocumentTitle(title: string) {
  useEffect(() => {
    document.title = title;
  }, [title]);
}
